module.exports = __webpack_public_path__ + "img/login-button.6db967c2.png";